//
// Validations
//
(function( $ ) {
  ti.generators = {
    string: function(options){

      //
      // Settings
      var settings = $.extend({
            length: 8
          }, options),

          id = "";

      while (id.length < settings.length) {
        id += Math.random().toString(36).substr(2);
      }
      return id.substr(0, settings.length);

    }
  }
}( jQuery ));
